import React, { Component } from "react";
import Cookies from "universal-cookie";
import MainLayout from "../../components/layouts/MainLayout";
import { withRouter } from "../../hoc/withRouter";
import withAuth from "../../hoc/withAuth";
import { Buffer } from "buffer";
import Spreadsheet from "react-spreadsheet";
import { Button, Card, Col, Form, Input, Modal, Row, Select, Tabs, message } from "antd";
import { UpdateStatusStockStates } from "./types/UpdateStatusStockTypes";
import { NotificationOutlined, SaveOutlined, CopyOutlined } from "@ant-design/icons";
import { stockOtodisService } from "../../services/otodisApi/StockOtodisService";
import moment from "moment";

export interface UploadVatCreditProps {}

class UpdateStatusStock extends Component<UploadVatCreditProps & any, UpdateStatusStockStates> {
  private readonly initState!: UpdateStatusStockStates;
  private token = new Cookies().get("_t");
  private columnLabels = ["Kode Dealer", "Nomor Mesin", "Status Stock", "Catatan"];
  private user = JSON.parse(Buffer.from(new Cookies().get("_u"), "base64").toString());

  constructor(props: (UploadVatCreditProps & any) | any) {
    super(props);

    const dealerCode = props.match.params.dealerCode.replace(/-/g, "#");

    this.initState = {
      dealerCode: dealerCode,
      submitting: false,
      engineNumber: "",
      stockStatus: null,
      stockNotes: "",
      dataSheet: [
        [{ value: dealerCode }, { value: "" }, { value: "" }, { value: "" }],
        [{ value: dealerCode }, { value: "" }, { value: "" }, { value: "" }],
        [{ value: dealerCode }, { value: "" }, { value: "" }, { value: "" }],
        [{ value: dealerCode }, { value: "" }, { value: "" }, { value: "" }],
        [{ value: dealerCode }, { value: "" }, { value: "" }, { value: "" }],
      ],
    };
    this.state = { ...this.initState };
  }

  onSheetChange = (newData: any) => {
    this.setState({ dataSheet: newData });
  };

  onDealerChange = async (data: any) => {
    this.setState({
      dealerCode: data.value,
    });
  };

  onFieldChange = <T extends keyof Pick<any, "engineNumber" | "stockStatus" | "stockNotes">>(target: T, value: any) => {
    const currentState: any = { ...this.state };
    switch (target) {
      case "stockStatus":
        currentState.stockStatus = value;
        break;
      case "engineNumber":
        currentState.engineNumber = value;
        break;
      case "stockNotes":
        currentState.stockNotes = value;
        break;
    }
    this.setState({
      ...currentState,
    });
  };

  inputVatManual = async () => {
    if (!this.state.stockStatus || !this.state.engineNumber || !this.state.stockNotes) {
      Modal.error({
        title: "Proses Gagal",
        content: "Mohon Lengkapi Data",
      });
      return;
    }

    const dataUpdate: any = [];
    for (const item of this.state.engineNumber.split(",")) {
      dataUpdate.push({
        dealer_code: this.state.dealerCode,
        engine_number: item?.trim(),
        status_stock: this.state.stockStatus,
        notes: this.state.stockNotes,
        updated_by: this.user,
      });
    }

    await this.promisedSetState({
      submitting: true,
    });

    try {
      stockOtodisService.setToken(this.token);
      await stockOtodisService.updateStockStatus(dataUpdate).then(async (successData) => {
        const currentTime = moment().format("YYYY-MM-DD HH:mm:ss");
        const successInfo = `
Status Baru Stock: ${this.state.stockStatus}
Nomor Mesin: ${this.state.engineNumber}
Catatan: ${this.state.stockNotes}
Waktu Update: ${currentTime}
        `;

        Modal.success({
          title: "Proses Sukses",
          content: (
            <div>
              <p>Data berhasil di update</p>
              <div style={{ background: "#f5f5f5", padding: "10px", borderRadius: "4px", marginTop: "10px" }}>
                <pre style={{ whiteSpace: "pre-wrap", margin: 0 }}>{successInfo}</pre>
              </div>
              <Button
                icon={<CopyOutlined />}
                style={{ marginTop: "10px" }}
                onClick={() => {
                  navigator.clipboard.writeText(successInfo);
                  message.success("Informasi berhasil disalin ke clipboard");
                }}
              >
                Salin Informasi
              </Button>
            </div>
          ),
        });
        await this.promisedSetState({
          submitting: false,
          engineNumber: "",
          stockNotes: "",
          stockStatus: null,
        });
      });
    } catch (e) {
      console.log("error", e);

      Modal.error({
        title: "Proses Gagal",
        content: "Server Menolak Inputan Anda :" + e,
      });
      await this.promisedSetState({
        submitting: false,
      });
    }
  };

  onSubmit = async () => {
    const dataUpdate: any = [];
    for (const item of this.state.dataSheet) {
      if (item[0]?.value && item[1]?.value && item[2]?.value && item[3]?.value) {
        dataUpdate.push({
          dealer_code: item?.[0]?.value?.trim()?.toUpperCase(),
          engine_number: item?.[1]?.value?.trim()?.toUpperCase(),
          status_stock: item?.[2]?.value?.trim()?.toUpperCase(),
          notes: item?.[3]?.value?.trim(),
          updated_by: this.user,
        });
      }
    }

    if (dataUpdate.length < 1) {
      Modal.error({ title: "Proses Gagal", content: "Mohon Lengkapi Data" });
      return;
    }

    await this.promisedSetState({
      submitting: true,
    });

    try {
      stockOtodisService.setToken(this.token);
      await stockOtodisService.updateStockStatus(dataUpdate).then(async (successData) => {
        Modal.success({
          title: "Proses Sukses",
          content: "data berhasil di update ",
        });
        setTimeout(function () {
          window.location.reload();
        }, 1500);
      });
    } catch (e) {
      console.log("error", e);
      Modal.error({
        title: "Proses Gagal",
        content: "Server Menolak Inputan Anda :" + e,
      });
      await this.promisedSetState({
        submitting: false,
      });
    }
  };
  promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

  render() {
    return (
      <React.Fragment>
        <MainLayout
          onChangeDealer={this.onDealerChange}
          breadcrumbPath={`Stock`}
          breadcrumbMenu={`Update Status Stock`}
          defaultSelectedKeys={["m-update-stock"]}
          defaultOpenKeys={["sm-stock", "sm-sm-stock"]}
        >
          <Tabs defaultActiveKey="1" style={{ padding: 0, margin: 0 }}>
            <Tabs.TabPane tab="Single Stock" key="1">
              <Row>
                <Col xs={24} xl={8}>
                  <Card title="Rubah Status Stock" style={{ margin: 10 }}>
                    <Form layout="vertical">
                      <Form.Item>
                        <div className={`text-small-grey`}>Status</div>
                        <Select placeholder="Rubah Status" showSearch optionFilterProp="children" onChange={(value) => this.onFieldChange("stockStatus", value)} value={this.state.stockStatus}>
                          <Select.Option key={`ACTIVE`} value={`ACTIVE`}>{`ACTIVE`}</Select.Option>
                          <Select.Option key={`DISPLAY`} value={`DISPLAY`}>{`DISPLAY`}</Select.Option>
                          <Select.Option key={`NOTFORSALE`} value={`NOTFORSALE`}>{`NOTFORSALE`}</Select.Option>
                        </Select>
                      </Form.Item>
                      <Form.Item label="Nomor Mesin">
                        <Input value={this.state.engineNumber} placeholder="Nomor Mesin" onChange={(event) => this.onFieldChange("engineNumber", event.target.value)} />
                      </Form.Item>
                      <Form.Item label="Catatan">
                        <Input.TextArea value={this.state.stockNotes} placeholder="Catatan" onChange={(event) => this.onFieldChange("stockNotes", event.target.value)} />
                      </Form.Item>
                      <i style={{ color: "grey", fontSize: "75%", marginTop: 20, marginBottom: 20 }}>
                        <NotificationOutlined style={{ cursor: "help" }} /> Gunakan tanda koma <b>,</b> untuk multi nomor mesin.
                      </i>
                      <br />
                      <br />
                      <Button type={"primary"} loading={this.state.submitting} onClick={() => this.inputVatManual()}>
                        Rubah Status Stock
                      </Button>
                    </Form>
                  </Card>
                </Col>
              </Row>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Multi Stock" key="2">
              <Button type={"primary"} icon={<SaveOutlined />} onClick={this.onSubmit} loading={this.state.submitting}>
                Rubah Status Stock
              </Button>
              <br />
              <br />
              <div className={`p-20`}>
                <Spreadsheet data={this.state.dataSheet} columnLabels={this.columnLabels} onChange={this.onSheetChange} />
              </div>
              <br />
              <br />
              <div style={{ fontSize: "80%" }}>
                Contoh Format: <br />
                <a href={`https://docs.google.com/spreadsheets/d/1z4P0d8zwupfsi3loEdKO57eEvVHPnno0X_pnUK4C_7A/edit?usp=sharing`} target={`_blank`}>
                  https://docs.google.com/spreadsheets/d/1z4P0d8zwupfsi3loEdKO57eEvVHPnno0X_pnUK4C_7A/edit?usp=sharing
                </a>
              </div>
            </Tabs.TabPane>
          </Tabs>
        </MainLayout>
      </React.Fragment>
    );
  }
}

export default withAuth(withRouter(UpdateStatusStock), 42);
